import React, { useEffect, useState } from "react";
import { Modal, Input, Switch } from "antd";

export const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return { isMobile };
};

const EditColumnModal = ({
  open,
  onClose,
  onUpdate,
  editTitle,
  setEditTitle,
  editPrivate,
  setEditPrivate,
  updatingColumn
}) => {
  const { isMobile } = useResponsive();

  return (
    <Modal
      title={<span className={isMobile ? 'text-base' : ''}>Edit Section</span>}
      open={open}
      onCancel={onClose}
      onOk={onUpdate}
      confirmLoading={updatingColumn}
      okText={isMobile ? "Update" : "Update Section"}
      cancelText="Cancel"
      okButtonProps={{ 
        disabled: !editTitle.trim(),
        style: { backgroundColor: '#298E9F' }
      }}
      width={isMobile ? '95vw' : 600}
      centered={isMobile}
    >
      <div className={`space-y-${isMobile ? '4' : '6'}`}>
        {/* Column Title */}
        <div>
          <label className={`block font-semibold text-gray-700 mb-2 ${isMobile ? 'text-xs' : 'text-sm'}`}>
            Section Title *
          </label>
          <Input
            placeholder="Enter column title"
            value={editTitle}
            onChange={(e) => setEditTitle(e.target.value)}
            size={isMobile ? 'middle' : 'large'}
            className="w-full"
          />
        </div>

        {/* Privacy Toggle */}
        <div className={`flex items-center justify-between ${isMobile ? 'p-3' : 'p-4'} bg-gray-50 rounded-lg`}>
          <div className="flex-1 pr-3">
            <div className={`font-semibold text-gray-700 ${isMobile ? 'text-sm' : ''}`}>
              Private Section
            </div>
            <div className={`text-gray-500 ${isMobile ? 'text-xs' : 'text-sm'}`}>
              {isMobile ? "Only visible to you" : "Only you can see this column's content"}
            </div>
          </div>
          <Switch
            checked={editPrivate}
            onChange={setEditPrivate}
            checkedChildren={isMobile ? "" : "Private"}
            unCheckedChildren={isMobile ? "" : "Public"}
          />
        </div>
      </div>
    </Modal>
  );
}
export default EditColumnModal;